export const getPokemonUrl = (itemId) => {
    return `https://pokeapi.co/api/v2/pokemon/${itemId}`; 
  }


//   export  const handleOnClickActions = ({id, itemAdded, setSelectedPokemonId, addPokemonToWishlist, dispatch}) => {
//     // setSelectedPokemonId(id)
//     console.log("item is clicked-------")
//       // dispatch(addPokemonToWishlist(id, itemAdded))
// }